import React, { useState, useEffect } from "react";
import "./Footer.css";
import Footer_Bolo_Logo from "../assets/Footer_Bolo_Logo.svg";
// import Arrow_Icon from "../assets/Arrow_Icon.svg";
import Cross from "../assets/Cross.svg";
import Mic from "../assets/Mic.svg";
import axios from "axios";
import Reload_Icon from "../assets/Reload.svg";
import Loader_Gif from "../assets/Loader_GIF.gif";

const Footer = () => {
  const [nameError, setNameError] = useState("");
  const [messageError, setMessageError] = useState("");
  // const [emailError, setEmailError] = useState("");
  const [formValues, setFormValues] = useState({ Name: "", Message: "" });
  const [showPopup, setShowPopup] = useState(false);
  // const [popupMessage, setPopupMessage] = useState("");
  const [captchaNum1, setCaptchaNum1] = useState(0);
  const [captchaNum2, setCaptchaNum2] = useState(0);
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaNum1(num1);
    setCaptchaNum2(num2);
    setCaptchaAnswer("");
  };

  const handleCaptchaChange = (event) => {
    setCaptchaAnswer(event.target.value);
  };

  // const isFormValidFooter = () => {
  //   const isNameValid =
  //     formValues.Name.trim().length >= 3 &&
  //     /^[A-Za-z\s]+$/.test(formValues.Name);

  //   const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
  //     formValues.Email.trim(),
  //   );

  //   const isCaptchaValid =
  //     parseInt(captchaAnswer, 10) === captchaNum1 + captchaNum2;

  //   return isNameValid && isEmailValid && isCaptchaValid;
  // };
  const isFormValidFooter = () => {
    const isNameValid =
      formValues.Name.trim().length >= 3 &&
      /^[A-Za-z\s]+$/.test(formValues.Name);

    const isMessageValid =
      formValues.Message.trim().length >= 10 &&
      formValues.Message.trim().length <= 500;

    const isCaptchaValid =
      parseInt(captchaAnswer, 10) === captchaNum1 + captchaNum2;

    return isNameValid && isMessageValid && isCaptchaValid;
  };

  // const validateEmail = (email) => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   if (!email) {
  //     setEmailError("Email is required");
  //   } else if (!emailRegex.test(email)) {
  //     setEmailError("Please enter a valid email address");
  //   } else {
  //     setEmailError("");
  //   }
  // };
  const validateMessage = (message) => {
    const trimmed = message.trim();
    if (!trimmed) {
      setMessageError("Message is required");
    } else if (trimmed.length < 10) {
      setMessageError("Message should be at least 10 characters");
    } else if (trimmed.length > 500) {
      setMessageError("Message should not exceed 500 characters");
    } else {
      setMessageError("");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "Name") {
      const nameRegex = /^[A-Za-z\s]*$/;
      if (nameRegex.test(value.trim())) {
        setFormValues({ ...formValues, [name]: value });
        setNameError("");
      } else {
        setNameError("Please enter correct name");
      }
    }

    // if (name === "Email") {
    //   validateEmail(value);
    //   setFormValues({ ...formValues, [name]: value });
    // }
    if (name === "Message") {
      validateMessage(value);
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // validation checks...
    const nameRegex = /^[A-Za-z\s]+$/;
    if (formValues.Name.trim() === "") {
      setNameError("Please enter your Name.");
      return;
    } else if (!nameRegex.test(formValues.Name)) {
      setNameError("Name should only contain letters.");
      return;
    } else if (formValues.Name.trim().length < 3) {
      setNameError("Name should be at least 3 characters.");
      return;
    }

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!emailRegex.test(formValues.Email)) {
    //   setEmailError("Please enter a valid email address.");
    //   return;
    // }
    const trimmedMessage = formValues.Message.trim();
    if (!trimmedMessage) {
      setMessageError("Please enter your message.");
      return;
    } else if (trimmedMessage.length < 10) {
      setMessageError("Message should be at least 10 characters.");
      return;
    } else if (trimmedMessage.length > 500) {
      setMessageError("Message should not exceed 500 characters.");
      return;
    }

    if (parseInt(captchaAnswer, 10) !== captchaNum1 + captchaNum2) {
      alert("Captcha verification failed. Please try again.");
      generateCaptcha();
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "http://192.168.0.162/Boloindia_Project/controllers/Footer_Form.php",
        // "https://boloindia.com/Boloindia_Project/controllers/Footer_Form.php",
        formValues,
        { headers: { "Content-Type": "application/json" } },
      );

      //  success
      setShowPopup(true);
      setFormValues({ Name: "", Message: "" });
      setMessageError(""); // clear old error
      generateCaptcha(); //  refresh captcha after success
    } catch (err) {
      if (err.response && err.response.data?.error) {
        setMessageError(err.response.data.error);
      } else {
        console.error("Error submitting form:", err);
        setMessageError("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleReloadCaptcha = () => {
    generateCaptcha();
  };

  return (
    <div className="Main_Footer_Details">
      <div className="Footer_Details_Split">
        {/* Left Section */}
        <div className="Footer_Left_Data">
          <div className="Footer_Details">
            <img src={Footer_Bolo_Logo} alt="Bolo_Logo" />
            <p>&copy;2026 Bolo-India Media Networks Pvt Ltd</p>
            <p className="Footer_CIN">CIN: U72900KA2022PTC161710</p>
            <a href="mailto:namaste@boloindia.com">
              <p className="Footer_Email">namaste@boloindia.com</p>
            </a>
            {/* <div className="Job_Apply_Button">
              <button type="button">
                Apply for a Job <img src={Arrow_Icon} alt="Arrow_Icon" />
              </button>
            </div> */}

            {/*  Terms of Services | Privacy Policy */}
            <div className="Footer_Terms_Links">
              <span
                className="Footer_Terms_Link"
                onClick={() => window.open("/Terms_of_use", "_blank")}
              >
                Terms of Use
              </span>
              <span className="Footer_Terms_Separator">|</span>
              <span
                className="Footer_Terms_Link"
                onClick={() => window.open("/Privacy_Policy", "_blank")}
              >
                Privacy Policy
              </span>
              <span className="Footer_Terms_Separator">|</span>
              <span
                className="Footer_Terms_Link"
                onClick={() => window.open("/Copyright_music_policy", "_blank")}
              >
                Copyright & Music Policy
              </span>
              <span className="Footer_Terms_Separator">|</span>

              <span
                className="Footer_Terms_Link"
                onClick={() =>
                  window.open("/Boloindia_Community_Guidelines", "_blank")
                }
              >
                Community Guidelines
              </span>
              <span className="Footer_Terms_Separator">|</span>

              <span
                className="Footer_Terms_Link"
                onClick={() => window.open("/Login")}
              >
                Delete Account
              </span>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="Footer_Right_Data">
          <form className="Contact_Details_Form">
            <h1>Feedback on our App!</h1>
            <div className="Each_Contact_Field">
              <input
                type="text"
                name="Name"
                value={formValues.Name}
                onChange={handleChange}
                placeholder=" "
              />
              <label>
                Name <span>*</span>
              </label>
              <div className="Error_Msg">{nameError && <p>{nameError}</p>}</div>
            </div>

            <div className="Each_Contact_Field Each_Contact_Field_Message">
              <textarea
                name="Message"
                value={formValues.Message}
                onChange={handleChange}
                placeholder=" "
                rows={1}
              />
              <label>
                Message <span>*</span>
              </label>
              <div className="Error_Msg">
                {messageError && <p>{messageError}</p>}
              </div>
            </div>

            {/* <div className="Each_Contact_Field">
              <input
                type="email"
                name="Email"
                value={formValues.Email}
                onChange={handleChange}
                placeholder=" "
              />
              <label>
                Email <span>*</span>
              </label>
              <div className="Error_Msg">
                {emailError && <p>{emailError}</p>}
              </div>
            </div> */}

            <div className="Captcha_Footer">
              <div className="Captcha_Block">
                <div className="numbers">
                  {captchaNum1} <label>+</label> {captchaNum2} <label>=</label>
                </div>
                <input
                  className="Input_Field_Footer"
                  type="text"
                  value={captchaAnswer}
                  onChange={handleCaptchaChange}
                  aria-label="Enter the result of the captcha"
                />
                <img
                  className="Re"
                  src={Reload_Icon}
                  onClick={handleReloadCaptcha}
                  alt="Reload"
                />
              </div>
            </div>

            <div className="Submit_Contact_Button">
              <button
                type="submit"
                id="Click_Contact"
                onClick={handleSubmit}
                disabled={!isFormValidFooter()}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>

      {/*  Popup Modal */}
      {showPopup && (
        <div className="display">
          <div className="title">
            <img
              src={Cross}
              alt="cross"
              className="close_btn"
              onClick={() => {
                setShowPopup(false);
                setFormValues({ Name: "", Message: "" });
              }}
            />
            <img src={Mic} alt="mic" />
            <h2>You’re Subscribed! </h2>
            <p>
              Namaste! We are <br />
              on the way. we’ll reach you soon...
            </p>
            {/* <p>{popupMessage}</p>
            <button onClick={() => setShowPopup(false)}>Close</button> */}
          </div>
        </div>
      )}

      {loading && (
        <div className="Loader_Overlay">
          <img src={Loader_Gif} alt="Loading..." className="Loader_Image" />
        </div>
      )}
    </div>
  );
};

export default Footer;
